module.exports = __webpack_public_path__ + "static/media/logo-inbursa-org.8f88681c.png";